import { QUERIES, matchMediaDirectiveName } from './match-media.utils';
import { $applySmart } from '../../../../helpers/digest/digest';

directive.prefixName = 'updIfMatchMedia';

/**
 * Wrapper around `ng-if`, adding/removing the given element from the DOM
 * based on media queries.
 */
export function directive(query) {
  const directiveName = matchMediaDirectiveName(directive.prefixName, query);

  return ($window, ngIfDirective) => {
    'ngInject';
    // Technique to re-use `ngIf` implementation:
    // https://stackoverflow.com/a/24065378/89594
    const ngIf = ngIfDirective[0];

    return {
      transclude: ngIf.transclude,
      priority: ngIf.priority,
      terminal: ngIf.terminal,
      restrict: ngIf.restrict,
      link: function($scope, $element, $attr) {
        // This directive is exactly like `ngIf`, only we provide a `$matches` local
        // boolean that is `true` if the given media query is a match.
        const mediaIf = $attr[directiveName] || '$matches';
        const mediaQueryList = $window.matchMedia(QUERIES[query]);
        const applySmart = $applySmart($scope);
        const handleMediaQueryListChange = () => applySmart();

        $attr.ngIf = scope =>
          $scope.$eval(mediaIf, { $matches: mediaQueryList.matches });
        ngIf.link.apply(ngIf, arguments);

        mediaQueryList.addListener(handleMediaQueryListChange);
        $scope.$on('$destroy', () => {
          mediaQueryList.removeListener(handleMediaQueryListChange);
        });
      },
    };
  };
}
